import React, { forwardRef } from 'react';

const Button = forwardRef((props, ref) => {
  return (
    <button
      ref={ref}
      className={`btn siplast--sg btn--primary ${props.large && 'btn--large'} ${
        props.darkmode && 'btn--on-dark'
      } ${props.outline && 'btn--outline'} ${props.className}`}
      type="button"
      id={props.id}
      disabled={props.disabled}
      {...props.fieldProps}
      onClick={props.onClick}
      {...props.dataProps}
    >
      {props.label}
    </button>
  );
});

export default Button;
